import { t } from 'ttag'
import { useMemo } from 'react'

import { SLB } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Option, OptionGroup } from '@h2/components/containers/optionGroup'
import { K12ElementaryIcon } from '@h2/components/icons/k12Elementary'
import { K12HighSchoolIcon } from '@h2/components/icons/k12HighSchool'
import { K12MiddleSchoolIcon } from '@h2/components/icons/k12MiddleSchool'
import { K12MixedIcon } from '@h2/components/icons/k12Mixed'
import { Card } from '@h2/common/components/card'

import { props } from './props'
import { ContentWrap, OptionBody } from './components'

import { Navigator } from '../highlights/navigator'
import { Back } from '../back'
import { Controls } from '../controls'

const K12Population = ({ inDialog, properties, validate, renderPanel }) => {
  const k12Population = useMemo(
    () => properties.k12Population,
    [properties.k12Population]
  )

  return (
    <Card inDialog={inDialog}>
      <Card.Highlight color={SLB}>
        <Navigator type="educator" />
      </Card.Highlight>
      <Card.Content>
        <ContentWrap>
          <Heading level="2" align="center" mb="12px">
            {t`K12 Population`}
          </Heading>
          <Text align="center">{t`Let us know your current level of education:`}</Text>
          <OptionGroup
            gap="15px"
            value={k12Population}
            onClick={value => validate({ k12Population: value })}>
            <Option value="elementary">
              <OptionBody>
                <K12ElementaryIcon size="large" />
                <span className="flex">
                  <span>{t`Elementary`}</span>
                  <span>{t`I'm in Grade 5 or under.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="middle">
              <OptionBody>
                <K12MiddleSchoolIcon size="large" />
                <span className="flex">
                  <span>{t`Middle School`}</span>
                  <span>{t`I'm in Grades 6-8.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="high">
              <OptionBody>
                <K12HighSchoolIcon size="large" />
                <span className="flex">
                  <span>{t`High School`}</span>
                  <span>{t`I'm in Grade 9-12.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="multiple">
              <OptionBody>
                <K12MixedIcon size="large" />
                <span className="flex">
                  <span>{t`Mixed`}</span>
                  <span>{t`I haven't completed High School but I've entered the world of work.`}</span>
                </span>
              </OptionBody>
            </Option>
          </OptionGroup>
          <Controls>
            <Back onClick={() => renderPanel('k12Program')} />
          </Controls>
        </ContentWrap>
      </Card.Content>
      <Card.Detour>
        <Back onClick={() => renderPanel('k12Program')} />
      </Card.Detour>
    </Card>
  )
}

K12Population.propTypes = { ...props }

export { K12Population }
